export { default as Details } from './Details';

